const galleryModal = document.querySelectorAll('.gallery-modal');

if (galleryModal.length > 0) {
  const toggleModal = (element, toggle) => {
    const parentElement = element.closest('[data-modal-parent]');
    const parentId = element.closest('[data-id]')?.getAttribute('data-id');
    const modal = parentElement?.querySelector(`[data-modal]${parentId ? `[data-id="${parentId}"]` : ''}`);
    modal?.classList.toggle('is-open-modal', toggle);
    toggleBodyScrollLock(toggle);
  };

  // Gallery Modal Thumb Sliders
  const galleryModalThumbSlider = document.querySelectorAll('[data-slider="gallery-modal__thumb-slider"]');
  const thumbSwipers = [];

  const galleryModalThumbOptions = {
    slidesPerView: 'auto',
    spaceBetween: 16,
    watchOverflow: true,
    centerInsufficientSlides: true,
    speed: 800,
    centeredSlides: true,
    centeredSlidesBounds: true,
  };

  galleryModalThumbSlider.forEach((el) => {
    const thumbSwiper = new Swiper(el, galleryModalThumbOptions);
    thumbSwipers.push(thumbSwiper);
  });

  // Gallery Modal Main Sliders
  const galleryModalSlider = document.querySelectorAll('[data-slider="gallery-modal__main-slider"]');

  galleryModalSlider.forEach((el, i) => {
    const mainParentEle = el.closest('.gallery-modal');
    const parentEle = el.closest('.swiper');
    const allSlides = parentEle.querySelectorAll('.swiper-slide');
    const sliderNav = mainParentEle.querySelector('.gallery-modal__nav');

    const arrowLeft = mainParentEle.querySelector('.swiper-button-prev');
    const arrowRight = mainParentEle.querySelector('.swiper-button-next');

    const galleryModalOptions = {
      slidesPerView: 1,
      spaceBetween: 16,
      watchOverflow: true,
      speed: 800,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        nextEl: arrowRight,
        prevEl: arrowLeft,
      },
      thumbs: {
        swiper: thumbSwipers[i], // Correctly link the matching thumb swiper
      },
    };

    const galleryModalSliderInit = new Swiper(el, galleryModalOptions);

    // Optional: jump to slide from thumbnail click
    attachEvent('[data-gallery-item]', 'click', (item) => {
      const parent = item.target.closest('[data-gallery-item]');
      const itemIndex = parent.getAttribute('data-gallery-item');
      galleryModalSliderInit.slideTo(itemIndex, 0);
    });

    if (allSlides.length === 1) {
      sliderNav.classList.add('hide');
    }
  });

  // Close modal
  attachEvent('[data-close-modal]', 'click', (ev) => {
    toggleModal(ev.target, false);
  });

  // Open modal
  attachEvent('[data-gallery-trigger]', 'click', (ev) => {
    toggleModal(ev.target, true);
    ev.preventDefault();
  });

  // Close modal on Escape key
  onKeydown('escape', () => {
    galleryModal.forEach((ev) => {
      toggleModal(ev, false);
    });
  });
}
